var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"is-size-7"},[_vm._v(" Se você tiver dúvidas precisar de ajuda com o nosso site, "),_c('a',{attrs:{"href":"mailto:covid19map-app@programming.com.br"}},[_vm._v(" mande um email pra gente ")])])
}]

export { render, staticRenderFns }